import { render, staticRenderFns } from "./SVGIcon.vue?vue&type=template&id=a3b3785a&functional=true&"
import script from "./SVGIcon.vue?vue&type=script&lang=js&"
export * from "./SVGIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports